module.exports = __webpack_public_path__ + "static/media/A1-25-Granoid-Trix-cod123.70bb12f3.png";